import { IApplicationState } from '../../types/redux';

export function getSubdomain(state: IApplicationState) {
  return state.subdomain;
}
